document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('se-cart')) return;

  const continueButtons = document.querySelectorAll('.se-continue');
  const lastCollectionUrl = localStorage.getItem('lastVisitedCollection');

  if (!lastCollectionUrl) return;

  continueButtons.forEach(function(button) {
    button.setAttribute('href', lastCollectionUrl);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/collections/')) {
    localStorage.setItem('lastVisitedCollection', window.location.href);
  }
});